import * as PIXI from "pixi.js";
import Layers from "../../../../src/layers/Layers";
import { EventBus, EnumEventBus } from "../managers/EventBus";
import { RootEventBus, EnumRootEventBus } from "../../../../src/managers/RootEventBus";
import { CALC_LINE_INITIAL_TEXT_OBJ } from "../types/Config";
import { Coord } from "../../../../src/types/Interface";


export default class CalculationLine extends PIXI.Container {
  private Layers = Layers.getInstance();
  private RootEventBus = RootEventBus;
  private EventBus = EventBus;
  private animationEnabled: boolean = true;

  constructor(coord: Coord) {
    super();
    Object.assign(this, coord);
    this.addText();
    this.addToLayer();

    this.EventBus.on(EnumEventBus.setCalcLine, (degree: string) => this.updateDegrees([Number(degree), Number(degree) / 2]))
    this.RootEventBus.on(EnumRootEventBus.completedIntroAnim, () => this.animationEnabled = false);
  }
  private generateText(text: { text: string, x: number, y: number, color: number, fontSize?: number, fontWeight?: PIXI.TextStyleFontWeight }) {
    const T = new PIXI.Text()
    T.text = text.text
    T.x = text.x;
    T.y = text.y;
    T.style.fill = text.color;
    T.style.fontSize = text.fontSize ? text.fontSize : 50
    T.style.fontWeight = text.fontWeight ? text.fontWeight : "500";
    this.addChild(T);
  }
  private addText() {
    const texts = CALC_LINE_INITIAL_TEXT_OBJ;
    texts.forEach(text => this.generateText(text));
  }
  updateDegrees(degrees: (number | string)[]) {
    if (this.animationEnabled) {
      return
    }
    (this.children[2] as PIXI.Text).text = `${degrees[1]}°`;
    (this.children[4] as PIXI.Text).text = `${degrees[0]}°`;
  }
  private addToLayer() {
    this.Layers.Info.addChild(this);
  }
}